import type { TFunction } from 'i18next'

import { localeTag } from '../i18n'

/**
 * Mesaj saat/gun bicimlendirmesi - WhatsApp tarzi sohbet gorunumu icin.
 *
 * `Intl` KULLANILIYOR, elle "HH:mm" YAZILMIYOR: 24 saatlik/12 saatlik (AM/PM)
 * secimi ve saat/dakika ayiraci dile gore degisiyor (Turkce 24 saat, bircok
 * Ingilizce yerel ayari 12 saat + AM/PM). `localeTag()` aktif dile gore
 * dogru BCP-47 etiketini veriyor.
 */
export function formatMessageTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(localeTag(), { hour: '2-digit', minute: '2-digit' }).format(date)
}

function dayKeyOf(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Yerel takvim gunu anahtari (`YYYY-MM-DD`) - UTC DEGIL, kullanicinin
 * kendi saat diliminde hangi gune denk geldigi onemli. */
export function dayKey(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return dayKeyOf(date)
}

/**
 * Gun ayraci etiketi: "Bugün" / "Dün" / tam tarih.
 *
 * Iki gunun karsilastirmasi YEREL takvim gunune gore - `dayKey()` ile ayni
 * kural, aksi halde ayrac ile mesajin kendi gorunen gunu ANLIK olarak
 * uyusmayabilirdi (ornegin gece yarisina yakin mesajlarda).
 */
export function formatDayLabel(iso: string, t: TFunction): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''

  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  const key = dayKeyOf(date)
  if (key === dayKeyOf(today)) return t('chat.date.today')
  if (key === dayKeyOf(yesterday)) return t('chat.date.yesterday')

  return new Intl.DateTimeFormat(localeTag(), {
    day: 'numeric',
    month: 'long',
    year: date.getFullYear() === today.getFullYear() ? undefined : 'numeric',
  }).format(date)
}

/**
 * Bir yanitin toplam uretim suresi - `chat.meta`deki tok/s ile AYNI mantik:
 * `Intl.DurationFormat` KULLANILMIYOR (tarayici destegi hala tutarsiz),
 * elle iki kademeli bicim (saniye / dakika+saniye) yeterli ve test edilmesi
 * kolay.
 */
export function formatDuration(totalSeconds: number, t: TFunction): string {
  const seconds = Math.max(0, Math.round(totalSeconds))
  if (seconds < 60) return t('chat.meta.durationSeconds', { seconds })
  return t('chat.meta.durationMinutes', { minutes: Math.floor(seconds / 60), seconds: seconds % 60 })
}
